import classes from "../ZapleczeMapaUserAndAdmin.module.css";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";

import Box from "@mui/material/Box";

// @ts-ignore TODO ts-ignore
import useHttp from '../../Components/CustomHooks/use-http.js';
// @ts-ignore TODO ts-ignore
import {getUrl} from "../../requests";
// @ts-ignore TODO ts-ignore
import {GoodListItem} from "../../Components/Atoms/GoodListItem";

// @ts-ignore TODO ts-ignore
import {Theme} from "../../Components/styles/styles";
// @ts-ignore TODO ts-ignore
import MapContainer from "../../Components/UI/Map/MapContainer";

// @ts-ignore TODO ts-ignore
import {Modal} from "@mui/material";
// @ts-ignore TODO ts-ignore
import {AddGoodForm} from "../../Components/AddGoodForm/AddGoodForm";
import dayjs from "dayjs";
import "dayjs/locale/pl";
// @ts-ignore TODO ts-ignore
import Popup from "../../Components/UI/Popup/Popup";
import {makeStyles} from "@mui/styles";
// @ts-ignore TODO ts-ignore
import {useDebounce} from "use-debounce";
// @ts-ignore TODO ts-ignore
import searchFunction from "../search";
// @ts-ignore TODO ts-ignore
import {Circles} from "react-loader-spinner";
// @ts-ignore TODO ts-ignore
import {GoodListItemAdmin} from "../../Components/Atoms/GoodListItemAdmin";
// @ts-ignore TODO ts-ignore
import {AcceptGoodForm} from "../../Components/ManageGoodForms/AcceptGoodForm";
// @ts-ignore TODO ts-ignore
import {ConfirmationForm} from "../../Components/ManageGoodForms/ConfirmationForm";
// @ts-ignore TODO ts-ignore
import {GoodHistoryCard} from "../../Components/ManageGoodForms/GoodHistoryCard";
// @ts-ignore TODO ts-ignore
import css from "./GoodMapManager.moodule.css";

import {useAuth0} from "@auth0/auth0-react";
import clsx from "clsx";
// @ts-ignore TODO ts-ignore
import {GoodFilterBuilder, GoodFilterInterface} from "../Model/GoodFilter";
import {GoodMapMenu} from "./GoodMapMenu";

const slizeSize = 40;
// @ts-ignore TODO ts-ignore
const useStyles = makeStyles((theme) => ({
    input: {
        color: "black",
        backgroundColor: "white",
        disableUnderline: "false",
        borderRadius: "24px",
    },
    root: {
        disableUnderline: "true",
        backgroundColor: "white",
        color: "black",
        borderRadius: "24px",
    },
    root_bad: {
        disableUnderline: "true",
        backgroundColor: "white",
        color: "red",
        borderRadius: "24px",
    },
    floatingLabelFocusStyle: {
        color: "black",
        "&.Mui-focused": {
            color: "#000000",
        },
    },
    closeIcon: {
        border: "1px solid transparent",
        backgroundColor: "white",
        display: "inline-block",
        verticalAlign: "middle",
        outline: "0",
        cursor: "pointer",
        position: "relative",
        padding: "10px",

        "&:after": {
            content: "X",
            display: "block",
            width: "15px",
            height: "15px",
            position: "absolute",
            backgroundColor: "#FA9595",
            Zindex: "400",
            right: "35px",
            top: "0",
            bottom: "0",
            margin: "auto",
            padding: "2px",
            borderRadius: "50%",
            textAlign: "center",
            color: "black",
            fontWeight: "normal",
            fontSize: "12px",
            boxShadow: "0 0 2px #E50F0F",
            cursor: "pointer",
        },
    },

    InputText: {
        width: "163px",
        height: "36px",
        margin: "0 71px 51.5px 11.4px",
        padding: "8.7px 122.2px 8.2px 25.5px",
        fontFamily: "Lato",
        fontSize: "30px",
        fontWeight: "900",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.3",
        letterSpacing: "5.4px",
        textAlign: "left",
        color: "#363636",
        "&:hover:not(.Mui-disabled)": {
            cursor: "default",
            backgroundColor: "white",
            color: "#363636",
        },
    },
    textStyle1: {
        color: "#2af9be",
    },
}));

// @ts-ignore TODO ts-ignore
export const GoodMapManager = (props) => {
    let givenLongitude = "";
    let givenLatitude = "";
    const goodLocation = React.useRef("");
    const editEntity = React.useRef(null);

    const [sValid, setSValid] = useState(true);
    const [open, setOpen] = useState(false);
    const [openEmpty, setOpenEmpty] = useState(false);
    const [openNumber, setopenNumber] = useState(false);
    const [enteredValue, setEnteredValue] = useState("");
    const [placeId, setplaceId] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [lat, setLat] = useState(0);
    const [lon, setLon] = useState(0);
    const {isLoading, error, sendRequest: fetchData} = useHttp();
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [refs, setRefs] = useState([]);
    const [editObject, setEditObject] = useState(null);
    const [goodTitle, setGoodTitle] = useState("");

    const [goodDescription, setGoodDescription] = useState("");
    const [goodTitleError, setgoodTitleError] = useState(false);
    const [goodLocationError, setgoodLocationError] = useState(false);
    const [goodDescriptionError, setgoodDescriptionError] = useState(false);
    const [openInprogress, setopenInprogress] = useState(false);
    const [notImplemented, setNotImplemented] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [openHistory, setopenHistory] = useState(false);
    const [value, setValue] = React.useState(" ");
    const [debounceValue] = useDebounce(value, 500);
    const [debouncePlaceId] = useDebounce(placeId, 700);
    const [runSearch, setRunSearch] = useState(true);
    const [itemList, setItemList] = useState([]);

    const emptyErrorMsg = "Wszystkie pola musza byc wypelnione!";
    const inprogressMsg = "Pracuję...";
    const [numberOfPointsForGood, setnumberOfPointsForGood] = useState(0);
    const [validationPointsForGood, setvalidationPointsForGood] = useState(" ");

    const [httpError, setHttpError] = useState("");
    const [openPopUp, setopenPopUp] = useState(false);
    const [popUpError, setpopUpError] = useState("");
    const [popUpTitle, setPopUpTitle] = useState("");
    const [preview, setPreview] = useState(false);

    // @ts-ignore TODO ts-ignore
    const {user} = useAuth0();

    // @ts-ignore TODO ts-ignore
    const submitCsvFile = async (theFile):Promise<void> => {

        const uri = encodeURI(`${getUrl()}/api/v1/rfsManagement/upload`);
        try {
            const response = await fetch(uri, {
                method: "PUT",
                headers: {accept: "*/*", Authorization: `Bearer ${props.auth.user}`},
                body: theFile ? theFile : new FormData(),
            }).catch((err) => {
                setHttpError(
                    `Brak danych, ${err.message ? err : "Wystąpił niezidentyfikowany problem"
                    }`
                );
                setPopUpTitle(httpError);
                setopenPopUp(true);
                throw new Error(
                    `${err ? err.message : "Prawdopodobnie problem sieciowy"}`
                );
            });

            if (!response.ok) {
                response
                    .json()
                    .then((data):void => {
                        setHttpError(
                            `Błąd: ${data?.status
                                ? data?.status
                                : data?.errorCode
                                    ? data.errorCode
                                    : ""
                            }, kategoria: ${data?.errorSubCode}, komunikat: ${data?.message
                            }, info: ${data?.info}`
                        );
                        setopenPopUp(true);
                        setpopUpError(
                            `Błąd: ${data?.status ? data?.status : ""}, kategoria: ${data?.errorSubCode
                            }, komunikat: ${data?.message}, info: ${data?.info}`
                        );
                        setPopUpTitle("Problem");
                        return;
                    })
                    .catch((error):void => {
                        setHttpError(
                            `${response ? response.status : "Prawdopodobnie problem sieciowy"
                            } `
                        );
                        setopenPopUp(true);
                        setpopUpError(`Error ${error}`);
                        setPopUpTitle("Problem");
                        return;
                    });
            } else {
                response
                    .json()
                    .then(async (data):Promise<void> => {
                        setpopUpError(
                            `Plik z zasięgami został załadowany, dodano: ${data} wpisów.`
                        );
                        return data;
                    })
                    .catch((error):void => console.log(`GK errorr attachment json ${error}`));

                setopenPopUp(true);

                setPopUpTitle(`Sukces!`);
                // @ts-ignore TODO ts-ignore
                setHttpError(false);
            }
        } catch (error) {
            // @ts-ignore TODO ts-ignore
            setHttpError(`${error.message}`);
            setopenPopUp(true);
            // @ts-ignore TODO ts-ignore
            setpopUpError(error.message);
            setPopUpTitle("Problem");
        }

    };

    // @ts-ignore TODO ts-ignore
    const enteredSearchHandler = useCallback((data):void => {
        if (!data?.result || error) {
            setSearchResults([]);
            if (props.cityId) {
                setplaceId(props.cityId);
            } else if (localStorage.getItem("cityId")) {
                // @ts-ignore TODO ts-ignore
                setplaceId(localStorage.getItem("cityId"));
            }
            return;
        }
        // @ts-ignore TODO ts-ignore
        setSearchResults([data?.result]);
        setLat(data?.result?.geometry?.location?.lat?.toFixed(4));
        setLon(data?.result?.geometry?.location?.lng?.toFixed(4));
    }, []);

    useEffect(():void => {
        if (props.menuIx === GoodMapMenu.ADD) {
            // @ts-ignore
            handleOpenNewDobro();
            return;
        }
    }, [props.menuIx]);

    useEffect(():void => {
        if (!runSearch || debounceValue?.trim().length < 4) {
            setFilterData([]);
            setRunSearch(false);
            return;
        }

        searchFunction(debounceValue, data, setFilterData);
        setRunSearch(false);
    }, [debounceValue, data]);

    useEffect(() => {
        setgoodTitleError(false);
        setgoodLocationError(false);
        setgoodDescriptionError(false);

        if (!goodTitle || goodTitle.trim().length === 0) {
            setgoodTitleError(true);
        }
        if (!goodLocation.current || goodLocation.current.trim().length === 0) {
            setgoodLocationError(true);
        }
        if (!goodDescription || goodDescription.trim().length === 0) {
            setgoodDescriptionError(true);
        }
    }, [goodTitle, goodLocation.current, goodDescription]);

    useEffect(() => {
        if (!data) {
            return;
        }
        const myrefs = data.reduce((acc, value) => {
            // @ts-ignore TODO ts-ignore
            acc[value.id] = React.createRef();
            return acc;
        }, {});
        // @ts-ignore TODO ts-ignore
        setRefs(myrefs);
    }, [data]);

    useEffect(():void => {
        if (error) {
            setOpen(true);
            setHttpError(error);
            return;
        }
        setOpen(false);
        // @ts-ignore TODO ts-ignore
        setHttpError(null);
    }, [error]);


    // @ts-ignore TODO ts-ignore
    const filterGood = (params, filter: GoodFilterInterface):void => {
        if (!params) {
            return;
        }
        if (filter == null) {
            return;
        }
        if (params.auth?.epid === null || params.auth.user === null) {
            return;
        }
        setopenInprogress(true);
        let reqConfig: string;
        if (params.auth.epid !== "ADMIN") {
            const requestBody: any = {
                limit: 100000,
                offset: 0,
            };

                                    requestBody.epid        = `${params.auth.epid}`;
            // if (filter.owner)       requestBody.owner       = filter.owner;
            // if (filter.description) requestBody.description = filter.description;
            // if (filter.dateFrom)    requestBody.dateFrom    = filter.dateFrom;
            // if (filter.dateTo)      requestBody.dateTo      = filter.dateTo;
            // if (filter.goodAddress) requestBody.goodAdress  = filter.goodAddress;
            // if (filter.pointsFrom)  requestBody.pointsFrom  = filter.pointsFrom;
            // if (filter.pointsTo)    requestBody.pointsTo    = filter.pointsTo;
            // if (filter.goodStage)   requestBody.goodStage   = filter.goodStage;
            //                         requestBody.limit       = filter.limit;
            //                         requestBody.offset      = filter.offset;

            // @ts-ignore TODO ts-ignore
            reqConfig = {
                url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                method: "POST",
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${params.auth.user}`,
                    "Content-Type": "application/json",
                },
                body: requestBody,
            };
        } else {
            const requestBody: any = {
                limit: 100000,
                offset: 0,
            };

            if (filter.epid)        requestBody.epid        = filter.epid;
            if (filter.owner)       requestBody.owner       = filter.owner;
            if (filter.description) requestBody.description = filter.description;
            if (filter.dateFrom)    requestBody.dateFrom    = filter.dateFrom;
            if (filter.dateTo)      requestBody.dateTo      = filter.dateTo;
            if (filter.goodAddress) requestBody.goodAddress = filter.goodAddress;
            if (filter.pointsFrom)  requestBody.pointsFrom  = filter.pointsFrom;
            if (filter.pointsTo)    requestBody.pointsTo    = filter.pointsTo;
            if (filter.goodStage)   requestBody.goodStage   = filter.goodStage;
                                    requestBody.limit       = filter.limit;
                                    requestBody.offset      = filter.offset;

            // @ts-ignore TODO ts-ignore
            reqConfig = {
                url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                method: "POST",
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${params.auth.user}`,
                    "Content-Type": "application/json",
                },
                body: requestBody,
            };
        }

        fetchData(reqConfig, preparePointsOfGood);
    }

    useEffect(():void => {
        console.log('GoodMapManager -> useEffect->[ filterReady, filter]: ', props.filterReady, props.filter);
        const filter = (new GoodFilterBuilder()).reset().build();
        filterGood(props, filter);
    }, [props.lat, props.lon, fetchData, props.auth.epid, props.auth.user]);

    useEffect(():void => {
        console.log('GoodMapManager -> useEffect->[ filterReady, filter]: ', props.filterReady, props.filter);
        filterGood(props, props.filter);
        props.setFilterReady(false)
    }, [props.filterReady, props.filter]);


    useEffect(() => {
        const myrefs = searchResults.reduce((acc, value) => {
            // @ts-ignore TODO ts-ignore
            acc[value?.id ? value?.id : value?.placeId] = React.createRef();
            return acc;
        }, {});
        // @ts-ignore TODO ts-ignore
        setRefs(myrefs);
    }, [searchResults]);

    useEffect(() => {
        if (debouncePlaceId) {
            fetchData(
                {
                    url: `${getUrl()}/api/v1/places/details?placeId=${debouncePlaceId}&sessionId=${encodeURIComponent(
                        props.sessionid
                    )}`,
                },
                enteredSearchHandler
            );
        }

    }, [debouncePlaceId, fetchData, props.sessionid, enteredSearchHandler]);


    // @ts-ignore TODO ts-ignore
    const saveDobroAction = (theFile) => {
        if (
            !goodTitle ||
            goodTitle.trim().length === 0 ||
            !goodLocation.current ||
            goodLocation.current.trim().length === 0 ||
            !goodDescription ||
            goodDescription.trim().length === 0
        ) {
            setOpenEmpty(true);
            return;
        }
        setOpenEmpty(false);

        // @ts-ignore TODO ts-ignore
        if (editObject && editObject.goodStage === `New`) {
            updateGood(null, null, null, theFile);
            return;
        }
        // @ts-ignore TODO ts-ignore
        createNewGood(null, null, null, theFile, editObject?.id);
    };

    const [openNewDobro, setOpenNewDobro] = React.useState(false);
    // @ts-ignore TODO ts-ignore
    const handleOpenNewDobro = (onClose) => {
        // @ts-ignore TODO ts-ignore
        setDateValue(new Date());
        goodLocation.current = "";
        setGoodDescription("");
        setEditObject(null);
        setEnteredValue("");

        setLat(props.lat);
        setLon(props.lon);

        setOpenNewDobro(true);
    };
    // @ts-ignore TODO ts-ignore
    const handleOpenEditDobro = (index) => {
        if (data[index] && filterData.length === 0) {
            // @ts-ignore TODO ts-ignore
            setDateValue(data[index].goodDate);
            // @ts-ignore TODO ts-ignore
            setEnteredValue(data[index].city);

            // @ts-ignore TODO ts-ignore
            if (data[index].geographicCoordinates && data[index].geographicCoordinates) {
                // @ts-ignore TODO ts-ignore
                setLat(data[index].geographicCoordinates.latitude);
                // @ts-ignore TODO ts-ignore
                givenLatitude = data[index].geographicCoordinates.latitude;
                // @ts-ignore TODO ts-ignore
                setLon(data[index].geographicCoordinates.longitude);
                // @ts-ignore TODO ts-ignore
                givenLongitude = data[index].geographicCoordinates.longitude;
            }

            setSearchResults([data[index]]);

            setOpenNewDobro(true);

            // @ts-ignore TODO ts-ignore
            if (!data[index]?.shortDescription) {
                // @ts-ignore TODO ts-ignore
                data[index] = {
                    // @ts-ignore TODO ts-ignore
                    ...data[index],
                    // @ts-ignore TODO ts-ignore
                    shortDescription: data[index]?.description.slice(0, 50),
                };
                // @ts-ignore TODO ts-ignore
                setEditObject({...data[index]});
                return;
            }
            // @ts-ignore TODO ts-ignore
            setEditObject({...data[index]});

            return;
        }
        // @ts-ignore TODO ts-ignore
        setDateValue(filterData[index].goodDate);
        // @ts-ignore TODO ts-ignore
        setEnteredValue(filterData[index].city);

        // @ts-ignore TODO ts-ignore
        if (filterData[index].geographicCoordinates && filterData[index].geographicCoordinates) {
            // @ts-ignore TODO ts-ignore
            setLat(filterData[index].geographicCoordinates.latitude);
            // @ts-ignore TODO ts-ignore
            setLon(filterData[index].geographicCoordinates.longitude);
        }

        setOpenNewDobro(true);

        // @ts-ignore TODO ts-ignore
        if (!filterData[index]?.shortDescription) {
            // @ts-ignore TODO ts-ignore
            filterData[index] = {
                // @ts-ignore TODO ts-ignore
                ...filterData[index],
                // @ts-ignore TODO ts-ignore
                shortDescription: filterData[index]?.description.slice(0, 50),
            };
            // @ts-ignore TODO ts-ignore
            setEditObject({...filterData[index]});
            return;
        }

        setSearchResults([filterData[index]]);
        // @ts-ignore TODO ts-ignore
        setEditObject({...filterData[index]});
    };
    const handleCloseNewDobro = ():void => {
        props.menuRef?.current?.deselectItem();
        props.setMenuIx?.(GoodMapMenu.NONE);
        setOpenNewDobro(false); // openNewDobro.current = false;
        setEditObject(null);
        if (preview === true) {
            setPreview((val):boolean => !val);
        }
        // props.menuRef.current.deselectItem();
        // setOpenNewDobro(false); // openNewDobro.current = false;
        // setEditObject(null);
        // if (preview === true) {
        //     setPreview((val) => !val);
        // }
    };
    const [dateValue, setDateValue] = React.useState(dayjs(new Date()));
    // @ts-ignore TODO ts-ignore
    const preparePointsOfGood = (data) => {
        if (!props.auth.epid) {
            return;
        }
        // @ts-ignore TODO ts-ignore
        data.sort((a, b) => {
            return a.updated < b.updated ? 1 : -1;
        });
        let _data = data;

        if (props.auth.epid !== "ADMIN") {
            // @ts-ignore TODO ts-ignore
            _data = data.filter((elem) => elem.goodStage !== "Archived");
        }

        setData(_data);
        setFilterData([]);
        setopenInprogress(false);
    };
    // @ts-ignore TODO ts-ignore
    const afterUpdatingGoodHandler = (data) => {
        setEditObject(null);
        afterAddingGoodHandler(data);
    };
    // @ts-ignore TODO ts-ignore
    const afterAddingGoodHandler = (data) => {
        handleCloseNewDobro();

        let reqConfig = "";
        if (props.auth.epid !== "ADMIN") {
            // @ts-ignore TODO ts-ignore
            reqConfig = {
                url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                // method: 'GET',
                method: "POST",
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${props.auth.user}`,
                    "Content-Type": "application/json",
                },
                body: {
                    epid: `${props.auth.epid}`,
                    limit: 100000,
                    offset: 0,
                },
            };
        } else {
            // @ts-ignore TODO ts-ignore
            reqConfig = {
                url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                // method: 'GET',
                method: "POST",
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${props.auth.user}`,
                    "Content-Type": "application/json",
                },
                body: {
                    limit: 100000,
                    offset: 0,
                },
            };
        }

        fetchData(reqConfig, preparePointsOfGood);
    };


    // @ts-ignore TODO ts-ignore
    const verifyGood = (description, location, title) => {
        fetchData(
            {
                url: `${getUrl()}/api/v1/goodWorkflow`,
                method: "POST",
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${props.auth.user}`,
                    "Content-Type": "application/json",
                },
                body: {
                    goodAction: "Send to acceptance stage 1",
                    good: {
                        // @ts-ignore TODO ts-ignore
                        id: editObject.id,
                        // @ts-ignore TODO ts-ignore
                        parentId: editObject.id,
                        // @ts-ignore TODO ts-ignore
                        goodStage: editObject?.goodStage,
                        // @ts-ignore TODO ts-ignore
                        created: editObject?.created,
                        // @ts-ignore TODO ts-ignore
                        updated: editObject?.updated,
                        // @ts-ignore TODO ts-ignore
                        owner: editObject?.owner,
                        epid: `${props.auth.epid}`,
                        // @ts-ignore TODO ts-ignore
                        geographicCoordinates: editObject?.geographicCoordinates,
                        // @ts-ignore TODO ts-ignore
                        shortDescription: editObject?.shortDescription,
                        // @ts-ignore TODO ts-ignore
                        description: editObject?.description,
                        // @ts-ignore TODO ts-ignore
                        goodDate: editObject?.goodDate,
                        // @ts-ignore TODO ts-ignore
                        score: parseInt(editObject?.score),
                        // @ts-ignore TODO ts-ignore
                        rejectReason: editObject?.rejectReason,
                        // @ts-ignore TODO ts-ignore
                        acceptReason: editObject?.acceptReason,
                        // @ts-ignore TODO ts-ignore
                        deleteReason: editObject?.deleteReason,
                        // @ts-ignore TODO ts-ignore
                        city: editObject?.city,
                        // @ts-ignore TODO ts-ignore
                        provinceName: editObject?.provinceName,
                        // @ts-ignore TODO ts-ignore
                        districtName: editObject?.districtName,
                        // @ts-ignore TODO ts-ignore
                        streetName: editObject?.streetName,
                        // @ts-ignore TODO ts-ignore
                        buildNumber: editObject?.buildNumber,
                        status: "Oczekuje na weryfikację",
                    },
                },
            },
            afterUpdatingGoodHandler
        );
    };
    // @ts-ignore TODO ts-ignore
    const updateGood = (location, description, title, theFile) => {
        fetchData(
            {
                url: `${getUrl()}/api/v1/goodWorkflow`,
                method: "POST",
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${props.auth.user}`,
                    "Content-Type": "application/json",
                },
                body: {
                    goodAction: "Save",
                    good: {
                        // @ts-ignore TODO ts-ignore
                        id: editObject.id,
                        // @ts-ignore TODO ts-ignore
                        parentId: editObject.id,
                        goodStage: "Public",
                        created: `${new Date().toISOString()}`,
                        updated: `${new Date().toISOString()}`,
                        owner: `${props.auth?.epid ? props.auth?.epid : " "}`,
                        epid: `${props.auth?.epid ? props.auth?.epid : " "}`,
                        geographicCoordinates: {
                            latitude: lat ? lat : props?.lat,
                            longitude: lon ? lon : props?.lon,
                        },
                        shortDescription: title ? title : goodTitle,
                        description: description ? description : goodDescription,
                        // @ts-ignore TODO ts-ignore
                        goodDate: new Date(dateValue).toISOString(),
                        score: 0,
                        rejectReason: " ",
                        acceptReason: " ",
                        deleteReason: " ",
                        city: location ? location : goodLocation.current,
                        provinceName: " ",
                        districtName: " ",
                        streetName: " ",
                        buildNumber: " ",
                        status: "Nowy",
                    },
                },
            },
            // @ts-ignore TODO ts-ignore
            async (data) => {
                if (theFile) {
                    const formData = new FormData();
                    formData.append("file", theFile);

                    const uri = encodeURI(
                        `${getUrl()}/api/v1/goodWorkflow/${data?.id}/image`
                    );

                    try {
                        const response = await fetch(uri, {
                            method: "PUT",
                            headers: {Authorization: `Bearer ${props.auth.user}`},
                            body: formData ? formData : new FormData(),
                        }).catch((err) => {
                            setHttpError(`Błąd: ${err?.message} ${err?.info}`);
                            setPopUpTitle("Problem");
                            setopenPopUp(true);
                            throw new Error(`Błąd: ${err.message} ${err.info}`);
                        });

                        if (!response.ok) {
                            response
                                .json()
                                .then((data) => {
                                    setHttpError(
                                        `${data?.errorCode} ${data?.errorSubCode}  ${data?.message} ${data?.info}`
                                    );

                                    setopenPopUp(true);
                                    setpopUpError(
                                        `Error ${response
                                            ? response.status
                                            : "Prawdopodobnie problem sieciowy"
                                        } error sub code ${data.errorSubCode} message: ${data.message
                                        } info: ${data.info}`
                                    );
                                    setPopUpTitle("Problem");
                                    return;
                                })
                                .catch((error) => {
                                    setHttpError(` Błąd: ${response?.status} ${error?.message}`);

                                    setopenPopUp(true);
                                    setpopUpError(`Error ${error?.message} ${error?.info}`);
                                    setPopUpTitle("Problem");
                                    return;
                                });
                        } else {
                            response
                                .json()
                                // @ts-ignore TODO ts-ignore
                                .then(async (data) => {
                                    setopenPopUp(true);
                                    setpopUpError(`Zaktualizowano dobro`);
                                    setPopUpTitle("Sukces!");
                                    setHttpError(`Zaktualizowano dobro`);
                                })
                                .catch((error) => {
                                    setopenPopUp(true);
                                    setpopUpError(`Błąd: ${error?.message} ${error?.info}`);
                                    setPopUpTitle("Problem!");
                                    setHttpError(`Błąd: ${error?.message} ${error?.info}`);
                                });
                        }
                    } catch (error) {
                        // @ts-ignore TODO ts-ignore
                        setHttpError(`Błąd: ${error?.message} ${error?.info}`);
                        setopenPopUp(true);
                        // @ts-ignore TODO ts-ignore
                        setpopUpError(`${error?.message} ${error?.info}`);
                        setPopUpTitle("Problem");
                    }
                }

                setopenPopUp(true);
                setpopUpError(`Zaktualizowano dobro`);
                setPopUpTitle("Sukces!");
                setHttpError(`Zaktualizowano dobro`);
                // @ts-ignore TODO ts-ignore
                afterAddingGoodHandler();
            }
        );
    };

    // @ts-ignore TODO ts-ignore
    const createNewGood = (location, description, title, theFile, id = null) => {
        const theGoodObject = {
            goodAction: "New",
            good: {
                parentId: `${id}`,
                goodStage: "New",
                created: `${new Date().toISOString()}`,
                updated: `${new Date().toISOString()}`,
                owner: `${props.auth?.epid ? props.auth?.epid : " "}`,
                epid: `${props.auth?.epid ? props.auth?.epid : " "}`,
                geographicCoordinates: {
                    latitude: lat ? lat : props?.lat,
                    longitude: lon ? lon : props?.lon,
                },
                shortDescription: title ? title : `${goodTitle}`,
                description: description ? description : goodDescription,
                // @ts-ignore TODO ts-ignore
                goodDate: new Date(dateValue).toISOString(),
                score: 0,
                rejectReason: " ",
                acceptReason: " ",
                deleteReason: " ",
                city: location ? location : goodLocation.current,
                provinceName: " ",
                districtName: " ",
                streetName: " ",
                buildNumber: " ",
                status: "Nowy",
            },
        };

        fetchData(
            {
                url: `${getUrl()}/api/v1/goodWorkflow`,
                method: "POST",
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${props.auth?.user}`,
                    "Content-Type": "application/json",
                },
                body: theGoodObject,
            },
            // @ts-ignore TODO ts-ignore
            async (data) => {
                if (theFile) {
                    const formData = new FormData();
                    formData.append("file", theFile);

                    const uri = encodeURI(
                        `${getUrl()}/api/v1/goodWorkflow/${data?.id}/image`
                    );

                    try {
                        const response = await fetch(uri, {
                            method: "PUT",
                            headers: {Authorization: `Bearer ${props.auth.user}`},
                            body: formData ? formData : new FormData(),
                        }).catch((err) => {
                            setHttpError(`Błąd: ${err?.message} ${err?.info}`);
                            setPopUpTitle("Problem");
                            setopenPopUp(true);
                            throw new Error(`Błąd: ${err.message} ${err.info}`);
                        });

                        if (!response.ok) {
                            response
                                .json()
                                .then((data) => {
                                    setHttpError(
                                        `${data?.errorCode} ${data?.errorSubCode}  ${data?.message} ${data?.info}`
                                    );

                                    setopenPopUp(true);
                                    setpopUpError(
                                        `Error ${response
                                            ? response.status
                                            : "Prawdopodobnie problem sieciowy"
                                        } error sub code ${data.errorSubCode} message: ${data.message
                                        } info: ${data.info}`
                                    );
                                    setPopUpTitle("Problem");
                                    return;
                                })
                                .catch((error) => {
                                    setHttpError(` Błąd: ${response?.status} ${error?.message}`);

                                    setopenPopUp(true);
                                    setpopUpError(`Error ${error?.message} ${error?.info}`);
                                    setPopUpTitle("Problem");
                                    return;
                                });
                        } else {
                            response
                                .json()
                                .then(async (data) => {
                                    setopenPopUp(true);
                                    setpopUpError(`Zaktualizowano dobro`);
                                    setPopUpTitle("Sukces!");
                                    setHttpError(`Dodano dobro`);
                                    return data;
                                })
                                .catch((error) => {
                                    setopenPopUp(true);
                                    setpopUpError(`Błąd: ${error?.message} ${error?.info}`);
                                    setPopUpTitle("Błąd!");
                                    // @ts-ignore TODO ts-ignore
                                    setHttpError(false);
                                });
                        }
                    } catch (error) {
                        // @ts-ignore TODO ts-ignore
                        setHttpError(`Błąd: ${error?.message} ${error?.info}`);
                        setopenPopUp(true);
                        // @ts-ignore TODO ts-ignore
                        setpopUpError(`${error?.message} ${error?.info}`);
                        setPopUpTitle("Problem");
                    }
                }
                // @ts-ignore TODO ts-ignore
                afterAddingGoodHandler();
            }
        );
    };

    // @ts-ignore TODO ts-ignore
    const auto_formSubmitHandler = (event, second) => {
        event.preventDefault();

        if (!enteredValue) {
            return;
        }
        if (enteredValue.trim().length < 4) {
            setSValid(false);
        }
        if (enteredValue.trim().length > 3) {
            setSValid(true);
        }
        auto_searchByIdHandler(enteredValue, "");
        localStorage.setItem("lastSearch", enteredValue);
    };

    // @ts-ignore TODO ts-ignore
    const auto_searchByIdHandler = (enteredValue, placeId) => {
        if (
            enteredValue != null &&
            enteredValue &&
            enteredValue.length > 0 &&
            enteredValue.match(/[\^¬~`§!£@#$%*|/\][{}]+/)
        ) {
            setSValid(false);
            setEnteredValue(enteredValue);
            return;
        }
        setSValid(true);
        setEnteredValue(enteredValue);

        goodLocation.current = enteredValue;
        if (placeId === "search") {
            return;
        }
        setplaceId(placeId);
        localStorage.setItem("last_place_id", placeId);

        if (!enteredValue) {
            return;
        }
        if (enteredValue.trim().length < 4 && !enteredValue.match(/[;!£@#$%^&]/)) {
            setSValid(true);
            localStorage.setItem("lastSearch", enteredValue);
        }
        if (enteredValue.trim().length > 3 && !enteredValue.match(/[;!£@#$%^&]/)) {
            localStorage.setItem("lastSearch", enteredValue);
            setSValid(true);
        }
    };

    // @ts-ignore TODO ts-ignore
    const clickacceptRow = (dobro) => {
        if (!dobro?.shortDescription) {
            dobro = {...dobro, shortDescription: dobro?.description.slice(0, 50)};
        }

        if (
            dobro &&
            dobro?.goodStage !== "Acceptance stage 2" &&
            props.auth.epid === "ADMIN"
        ) {
            setopenInprogress(true);

            fetchData(
                {
                    url: `${getUrl()}/api/v1/goodWorkflow`,
                    method: "POST",
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${props.auth?.user}`,
                        "Content-Type": "application/json",
                    },
                    body: {
                        goodAction: `Send to acceptance stage 2`,
                        good: {
                            id: dobro?.id,
                            parentId: dobro?.id,
                            goodStage: dobro?.goodStage,
                            created: dobro?.created,
                            updated: dobro?.updated,
                            owner: dobro?.owner,
                            epid: `${props.auth?.epid}`,
                            geographicCoordinates: dobro?.geographicCoordinates,
                            shortDescription: dobro?.shortDescription,
                            description: dobro?.description,
                            goodDate: dobro?.goodDate,
                            score: parseInt(dobro?.score),
                            rejectReason: dobro?.rejectReason,
                            acceptReason: dobro?.acceptReason,
                            deleteReason: dobro?.deleteReason,
                            city: dobro?.city,
                            provinceName: dobro?.provinceName,
                            districtName: dobro?.districtName,
                            streetName: dobro?.streetName,
                            buildNumber: dobro?.buildNumber,
                            status: "Oczekuje na weryfikację",
                        },
                    },
                },
                () => {
                    fetchData(
                        {
                            url: `${getUrl()}/api/v1/goodWorkflow/${dobro.id}`,
                            method: "GET",
                            headers: {accept: "*/*", Authorization: `Bearer ${props.auth.user}`},
                        },
                        // @ts-ignore TODO ts-ignore
                        (data) => {
                            editEntity.current = {...data};
                            setEditObject({...data});
                            setopenInprogress(false);
                            setOpenNewDobro(true);

                            let reqConfig = "";
                            if (props.auth.epid !== "ADMIN") {
                                // @ts-ignore TODO ts-ignore
                                reqConfig = {
                                    // url: `${getUrl()}/api/v1/goodWorkflow?limit=100000`,
                                    url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                                    // method: 'GET',
                                    method: "POST",
                                    headers: {
                                        accept: "*/*",
                                        Authorization: `Bearer ${props.auth.user}`,
                                        "Content-Type": "application/json",
                                    },
                                    body: {
                                        epid: `${props.auth.epid}`,
                                        limit: 100000,
                                        offset: 0,
                                    },
                                };
                            } else {
                                // @ts-ignore TODO ts-ignore
                                reqConfig = {
                                    // url: `${getUrl()}/api/v1/goodWorkflow?limit=100000`,
                                    url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                                    // method: 'GET',
                                    method: "POST",
                                    headers: {
                                        accept: "*/*",
                                        Authorization: `Bearer ${props.auth.user}`,
                                        "Content-Type": "application/json",
                                    },
                                    body: {
                                        limit: 100000,
                                        offset: 0,
                                    },
                                };
                            }

                            fetchData(reqConfig, preparePointsOfGood);
                        }
                    );
                }
            );

            return;
        }

        editEntity.current = {...dobro};
        setEditObject({...dobro});
        setPreview(false);
        setOpenNewDobro(true);
        return;
    };

    const content = (

        <Box
            className={clsx(css.mainPanel)}
            id="good-points"

            // sx={{
            //     overflow: "auto",
            //     height: "calc(100vh - var(--menu-glowne-height) - var(--menu-zaplecze-height) - var(--goodMapManager-toolbar-height))",
            //     width: "100%"
            // }}
        >
            <div>
                {filterData.length === 0 &&
                    data.map((dobro, i) => {
                        // @ts-ignore TODO ts-ignore
                        let theDate = new Date(`${dobro.goodDate}`);
                        return (
                            <Box
                                key={i}
                                sx={{
                                    margin: "10px",
                                }}
                            >
                                {props.auth.epid !== "ADMIN" && (
                                    <GoodListItem
                                        goodName={
                                            // @ts-ignore TODO ts-ignore
                                            dobro?.shortDescription ? dobro?.shortDescription : dobro.description.slice(0, 50)
                                        }
                                        date={theDate.toLocaleDateString("pl-pl", {
                                            weekday: "short",
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                        })}
                                        // @ts-ignore TODO ts-ignore
                                        location={`${dobro.city.slice(0, 20)}`}
                                        // @ts-ignore TODO ts-ignore
                                        goodPionts={dobro.score}
                                        status={
                                            // @ts-ignore TODO ts-ignore
                                            dobro?.goodStage === "Archived" ? "Usunięto" : `${dobro.status.slice(0, 17)}.`
                                        }
                                        onClickEdit={() => {
                                            handleOpenEditDobro(i);
                                        }}
                                        editObject={{}}
                                        onClickHistory={() => {
                                            fetchData(
                                                {
                                                    // @ts-ignore TODO ts-ignore

                                                    url: `${getUrl()}/api/v1/goodWorkflow/history/${dobro.id
                                                    }`,
                                                    method: "GET",
                                                    headers: {
                                                        accept: "*/*",
                                                        Authorization: `Bearer ${props.auth.user}`,
                                                    },
                                                },
                                                // @ts-ignore TODO ts-ignore
                                                (data) => {
                                                    // @ts-ignore TODO ts-ignore
                                                    let itemList = [];
                                                    // @ts-ignore TODO ts-ignore
                                                    data?.forEach((elem) => {
                                                        let theDate = new Date(
                                                            `${elem?.trxDate}`
                                                        ).toLocaleDateString("pl-pl", {
                                                            weekday: "short",
                                                            year: "numeric",
                                                            month: "numeric",
                                                            day: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                        });
                                                        itemList.push({
                                                            date: theDate,
                                                            updatedBy: elem?.username,
                                                            comments: "brak",
                                                            status:
                                                                elem?.toStage === "Acceptance stage 1"
                                                                    ? "Oczekuje na weryfikację"
                                                                    : elem?.toStage === "Acceptance stage 2"
                                                                        ? "W trakcie weryfikacji"
                                                                        : elem?.toStage === "Archived"
                                                                            ? "Usunięto"
                                                                            : elem?.toStage === "Public"
                                                                                ? "Akceptacja"
                                                                                : elem?.toStage === "New"
                                                                                    ? "Nowy"
                                                                                    : "",
                                                        });
                                                    });
                                                    // @ts-ignore TODO ts-ignore
                                                    setItemList(itemList);

                                                    setopenHistory((val) => !val);
                                                }
                                            );
                                        }}
                                        onClickPreview={() => {
                                            setPreview(true);
                                            handleOpenEditDobro(i);
                                        }}
                                        onClickDelete={() => {
                                            // @ts-ignore TODO ts-ignore
                                            editEntity.current = {...dobro};
                                            setConfirmation((val) => !val);
                                        }}
                                        itemList={
                                            // @ts-ignore TODO ts-ignore
                                            dobro.status === "Oczekuje na weryfikację"
                                                ? ["Edycja dobra", "Usuń dobro", "Historia"]
                                                // @ts-ignore TODO ts-ignore
                                                : dobro.status === "W trakcie weryfikacji"
                                                    ? ["Podgląd dobra", "Usuń dobro", "Historia"]
                                                    // @ts-ignore TODO ts-ignore
                                                    : dobro.status === "Usunięto"
                                                        ? ["Edycja dobra", "Usuń dobro"]
                                                        // @ts-ignore TODO ts-ignore
                                                        : dobro.status === "Akceptacja"
                                                            ? ["Edycja dobra", "Usuń dobro", "Historia"]
                                                            : ["Edycja dobra", "Usuń dobro", "Historia"]
                                        }
                                    />
                                )}
                                {props.auth.epid === "ADMIN" && (
                                    <GoodListItemAdmin
                                        // @ts-ignore TODO ts-ignore
                                        epid={dobro?.epid}
                                        goodName={
                                            // @ts-ignore TODO ts-ignore
                                            dobro?.shortDescription ? dobro?.shortDescription : dobro?.description.slice(0, 50)
                                        }
                                        date={theDate.toLocaleDateString("pl-pl", {
                                            weekday: "short",
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                        })}
                                        // @ts-ignore TODO ts-ignore
                                        location={`${dobro.city.slice(0, slizeSize)}`}
                                        // @ts-ignore TODO ts-ignore
                                        goodPionts={dobro.score}
                                        status={
                                            // @ts-ignore TODO ts-ignore
                                            dobro?.goodStage === "Archived" ? "Usunięto" : `${dobro.status.slice(0, 17)}.`
                                        }
                                        rejectDisabled={
                                            // @ts-ignore TODO ts-ignore
                                            dobro.goodStage === "Acceptance stage 1" ? true : false
                                        }
                                        clickaccept={() => {
                                            // @ts-ignore TODO ts-ignore
                                            clickacceptRow({...dobro});
                                        }}
                                        onClickReject={() => {
                                            // @ts-ignore TODO ts-ignore
                                            editEntity.current = {...dobro};
                                            setConfirmation((val) => !val);
                                        }}
                                        onClickEdit={() => {
                                            setNotImplemented((v) => !v);
                                        }}
                                        onClickHistory={() => {
                                            fetchData(
                                                {
                                                    // @ts-ignore TODO ts-ignore
                                                    url: `${getUrl()}/api/v1/goodWorkflow/history/${dobro.id
                                                    }`,
                                                    method: "GET",
                                                    headers: {
                                                        accept: "*/*",
                                                        Authorization: `Bearer ${props.auth.user}`,
                                                    },
                                                },
                                                // @ts-ignore TODO ts-ignore
                                                (data) => {
                                                    // @ts-ignore TODO ts-ignore
                                                    let itemList = [];
                                                    // @ts-ignore TODO ts-ignore
                                                    data?.forEach((elem) => {
                                                        let theDate = new Date(
                                                            `${elem?.trxDate}`
                                                        ).toLocaleDateString("pl-pl", {
                                                            weekday: "short",
                                                            year: "numeric",
                                                            month: "numeric",
                                                            day: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                        });
                                                        itemList.push({
                                                            date: theDate,
                                                            updatedBy: elem?.username,
                                                            comments: "brak",
                                                            status:
                                                                elem?.toStage === "Acceptance stage 1"
                                                                    ? "Oczekuje na weryfikację"
                                                                    : elem?.toStage === "Acceptance stage 2"
                                                                        ? "W trakcie weryfikacji"
                                                                        : elem?.toStage === "Archived"
                                                                            ? "Usunięto"
                                                                            : elem?.toStage === "Public"
                                                                                ? "Akceptacja"
                                                                                : elem?.toStage === "New"
                                                                                    ? "Nowy"
                                                                                    : "",
                                                        });
                                                    });
                                                    // @ts-ignore TODO ts-ignore
                                                    setItemList(itemList);
                                                    setopenHistory((val) => !val);
                                                }
                                            );
                                        }}
                                        onClickPreview={() => {
                                            setopenInprogress((val) => !val);
                                            setPreview(true);
                                            handleOpenEditDobro(i);
                                            setopenInprogress((val) => !val);
                                        }}
                                        itemList={["Historia", "Podgląd dobra"]}
                                    />
                                )}
                            </Box>
                        );
                    })}
                {filterData.length > 0 &&
                    filterData.map((dobro, i) => {
                        // @ts-ignore TODO ts-ignore
                        let theDate = new Date(`${dobro.goodDate}`);
                        return (
                            <Box
                                key={i}
                                sx={{
                                    margin: "10px",
                                }}
                            >
                                {props.auth.epid !== "ADMIN" && (
                                    <GoodListItem
                                        goodName={
                                            // @ts-ignore TODO ts-ignore
                                            dobro?.shortDescription ? dobro?.shortDescription : dobro?.description.slice(0, 50)
                                        }
                                        date={theDate.toLocaleDateString("pl-pl", {
                                            weekday: "short",
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                        })}
                                        // @ts-ignore TODO ts-ignore
                                        location={`${dobro.city.slice(0, 20)}`}
                                        // @ts-ignore TODO ts-ignore
                                        goodPionts={dobro.score}
                                        status={
                                            // @ts-ignore TODO ts-ignore
                                            dobro?.goodStage === "Archived" ? "Usunięto" : `${dobro.status.slice(0, 17)}.`
                                        }
                                        onClickEdit={():void => {
                                            handleOpenEditDobro(i);
                                        }}
                                        editObject={{}}
                                        onClickHistory={():void => {
                                            fetchData(
                                                {
                                                    // @ts-ignore TODO ts-ignore
                                                    url: `${getUrl()}/api/v1/goodWorkflow/history/${dobro.id
                                                    }`,
                                                    method: "GET",
                                                    headers: {
                                                        accept: "*/*",
                                                        Authorization: `Bearer ${props.auth.user}`,
                                                    },
                                                },
                                                // @ts-ignore TODO ts-ignore
                                                (data) => {
                                                    // @ts-ignore TODO ts-ignore
                                                    let itemList = [];
                                                    // @ts-ignore TODO ts-ignore
                                                    data?.forEach((elem) => {
                                                        let theDate = new Date(
                                                            `${elem?.trxDate}`
                                                        ).toLocaleDateString("pl-pl", {
                                                            weekday: "short",
                                                            year: "numeric",
                                                            month: "numeric",
                                                            day: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                        });
                                                        itemList.push({
                                                            date: theDate,
                                                            updatedBy: elem?.username,
                                                            comments: "brak",
                                                            status:
                                                                elem?.toStage === "Acceptance stage 1"
                                                                    ? "Oczekuje na weryfikację"
                                                                    : elem?.toStage === "Acceptance stage 2"
                                                                        ? "W trakcie weryfikacji"
                                                                        : elem?.toStage === "Archived"
                                                                            ? "Usunięto"
                                                                            : elem?.toStage === "Public"
                                                                                ? "Akceptacja"
                                                                                : elem?.toStage === "New"
                                                                                    ? "Nowy"
                                                                                    : "",
                                                        });
                                                    });
                                                    // @ts-ignore TODO ts-ignore
                                                    setItemList(itemList);

                                                    setopenHistory((val) => !val);
                                                }
                                            );
                                        }}
                                        onClickPreview={() => {
                                            setPreview(true);
                                            handleOpenEditDobro(i);
                                        }}
                                        onClickDelete={() => {
                                            // @ts-ignore TODO ts-ignore
                                            editEntity.current = {...dobro};
                                            setConfirmation((val) => !val);
                                        }}
                                        itemList={
                                            // @ts-ignore TODO ts-ignore
                                            dobro.status === "Oczekuje na weryfikację"
                                                ? ["Edycja dobra", "Usuń dobro", "Historia"]
                                                // @ts-ignore TODO ts-ignore
                                                : dobro.status === "W trakcie weryfikacji"
                                                    ? ["Podgląd dobra", "Usuń dobro", "Historia"]
                                                    // @ts-ignore TODO ts-ignore
                                                    : dobro.status === "Usunięto"
                                                        // @ts-ignore TODO ts-ignore
                                                        ? ["Edycja dobra", "Usuń dobro"]
                                                        // @ts-ignore TODO ts-ignore
                                                        : dobro.status === "Akceptacja"
                                                            ? ["Edycja dobra", "Usuń dobro", "Historia"]
                                                            : ["Edycja dobra", "Usuń dobro", "Historia"]
                                        }
                                    />
                                )}
                                {props.auth.epid === "ADMIN" && (
                                    <GoodListItemAdmin
                                        goodName={
                                            // @ts-ignore TODO ts-ignore
                                            dobro?.shortDescription ? dobro?.shortDescription : dobro?.description.slice(0, 50)
                                        }
                                        date={theDate.toLocaleDateString("pl-pl", {
                                            weekday: "short",
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                        })}
                                        // @ts-ignore TODO ts-ignore
                                        location={`${dobro.city.slice(0, slizeSize)}`}
                                        // @ts-ignore TODO ts-ignore
                                        goodPionts={dobro.score}
                                        status={
                                            // @ts-ignore TODO ts-ignore
                                            dobro?.goodStage === "Archived" ? "Usunięto" : `${dobro.status.slice(0, 17)}.`
                                        }
                                        rejectDisabled={
                                            // @ts-ignore TODO ts-ignore
                                            dobro.goodStage === "Acceptance stage 1" ? true : false
                                        }
                                        clickaccept={() => {
                                            // @ts-ignore TODO ts-ignore
                                            clickacceptRow({...dobro});
                                        }}
                                        // @ts-ignore TODO ts-ignore
                                        onClickReject={(): void => {
                                            // @ts-ignore TODO ts-ignore
                                            editEntity.current = {...dobro};
                                            setConfirmation((val): boolean => !val);
                                        }}
                                        onClickEdit={() => {
                                            setNotImplemented((v): boolean => !v);
                                        }}
                                        onClickHistory={() => {
                                            fetchData(
                                                {
                                                    // @ts-ignore TODO ts-ignore
                                                    url: `${getUrl()}/api/v1/goodWorkflow/history/${dobro.id}`,
                                                    method: "GET",
                                                    headers: {
                                                        accept: "*/*",
                                                        Authorization: `Bearer ${props.auth.user}`,
                                                    },
                                                },
                                                // @ts-ignore TODO ts-ignore
                                                (data) => {
                                                    // @ts-ignore TODO ts-ignore
                                                    let itemList = [];
                                                    // @ts-ignore TODO ts-ignore
                                                    data?.forEach((elem) => {
                                                        let theDate = new Date(
                                                            `${elem?.trxDate}`
                                                        ).toLocaleDateString("pl-pl", {
                                                            weekday: "short",
                                                            year: "numeric",
                                                            month: "numeric",
                                                            day: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                        });
                                                        itemList.push({
                                                            date: theDate,
                                                            updatedBy: elem?.username,
                                                            comments: "brak",
                                                            status:
                                                                elem?.toStage === "Acceptance stage 1"
                                                                    ? "Oczekuje na weryfikację"
                                                                    : elem?.toStage === "Acceptance stage 2"
                                                                        ? "W trakcie weryfikacji"
                                                                        : elem?.toStage === "Archived"
                                                                            ? "Usunięto"
                                                                            : elem?.toStage === "Public"
                                                                                ? "Akceptacja"
                                                                                : elem?.toStage === "New"
                                                                                    ? "Nowy"
                                                                                    : "",
                                                        });
                                                    });
                                                    // @ts-ignore TODO ts-ignore
                                                    setItemList(itemList);

                                                    setopenHistory((val) => !val);
                                                }
                                            );
                                        }}
                                        onClickPreview={() => {
                                            setopenInprogress((val) => !val);
                                            setPreview(true);
                                            handleOpenEditDobro(i);
                                            setopenInprogress((val) => !val);
                                        }}
                                        itemList={["Historia", "Podgląd dobra"]}
                                    />
                                )}
                            </Box>
                        );
                    })}
            </div>
        </Box>
    );

    // @ts-ignore TODO ts-ignore
    function debounce(func, timeout = 750) {
        // @ts-ignore TODO ts-ignore
        let timer;
        // @ts-ignore TODO ts-ignore
        return (...args) => {
            // @ts-ignore TODO ts-ignore
            clearTimeout(timer);
            timer = setTimeout(() => {
                // @ts-ignore TODO ts-ignore
                func.apply(this, args);
            }, timeout);
        };
    }

    // @ts-ignore TODO ts-ignore
    const processChange = debounce((event) => {
        if (event.target.value === value) {
            return;
        }
        setRunSearch(true);
        doSearch(event);
    });


    // @ts-ignore TODO ts-ignore
    const doSearch = (event) => {
        if (event.target.value.value === `${value}`) {
            setRunSearch(false);
        }
        setValue(event.target.value);
    };

    // @ts-ignore TODO ts-ignore
    const classesTextField = useStyles();

    const goodFormModal =
        props.auth.epid !== "ADMIN" || (preview && props.auth.epid === "ADMIN") ? (
            <AddGoodForm
                topLabel={
                    !editObject
                        ? "Dodaj dobro"
                        : !preview &&
                        editObject &&
                        // @ts-ignore TODO ts-ignore
                        editObject.status === "Akceptacja" &&
                        // @ts-ignore TODO ts-ignore
                        editObject.goodStage !== "Public"
                            ? "Wniosek w procesie akceptacji nie można edytować"
                            : !preview &&
                            editObject &&
                            // @ts-ignore TODO ts-ignore
                            editObject.status === "Akceptacja" &&
                            // @ts-ignore TODO ts-ignore
                            editObject.goodStage === "Public"
                                ? `Dodaj dobro`
                                : !preview &&
                                editObject &&
                                // @ts-ignore TODO ts-ignore
                                editObject.status === "W trakcie weryfikacji" &&
                                // @ts-ignore TODO ts-ignore
                                editObject.goodStage === "Acceptance stage 2"
                                    ? "Wniosek w procesie weryfikacji nie można edytować"
                                    : // (!preview && editObject && editObject.goodStage === 'Public') ? 'Wniosek publiczny nie można edytować' :
                                    // @ts-ignore TODO ts-ignore
                                    !preview && editObject && editObject.status === "Nowy"
                                        ? "Popraw dobro lub wyślij do weryfikacji"
                                        // @ts-ignore TODO ts-ignore
                                        : !preview && editObject && editObject.status === "Usunięto"
                                            ? "Wniosek odrzucony nie można edytować"
                                            : !preview &&
                                            editObject &&
                                            // @ts-ignore TODO ts-ignore
                                            editObject.status === "Oczekuje na weryfikację"
                                                ? "Wniosek wysłany do weryfikacji"
                                                : preview
                                                    ? "Podgląd dobra"
                                                    : ` `
                }
                topText="Wprowadź szczegóły dotyczące miejsca oraz zrealizowanego dobra"
                titleLabel="Tytuł"
                // @ts-ignore TODO ts-ignore
                titleText={editObject ? editObject.shortDescription : ""}
                locationLabel="Miejsce dobra"
                titlePlaceHolder="Internet dla dzieci"
                locationPlaceHolder="Gromadka"
                descriptionPlaceHolder="opis dobra - maksymalnie 450 znaków"
                descriptionLabel="opis dobra"
                // @ts-ignore TODO ts-ignore
                locationText={editObject ? editObject.city : ""}
                // @ts-ignore TODO ts-ignore
                descriptionText={editObject ? editObject.description : ""}
                disableVerifyButton={
                    !editObject ||
                    // @ts-ignore TODO ts-ignore
                    editObject.status === "Oczekuje na weryfikację" ||
                    // @ts-ignore TODO ts-ignore
                    editObject.status === "Usunięto" ||
                    // @ts-ignore TODO ts-ignore
                    editObject.status === "W trakcie weryfikacji" ||
                    // @ts-ignore TODO ts-ignore
                    editObject.status === "Akceptacja" ||
                    preview === true
                }
                disableSaveButton={
                    (editObject &&
                        // @ts-ignore TODO ts-ignore
                        (editObject.status === "Usunięto" ||
                            // @ts-ignore TODO ts-ignore
                            editObject.status === "W trakcie weryfikacji")) ||
                    preview === true
                }
                cancelAction={() => {
                    handleCloseNewDobro();
                }}
                dateValue={dateValue}
                // @ts-ignore TODO ts-ignore
                picture={editObject?.image}
                handleChangeDate={setDateValue}
                // @ts-ignore TODO ts-ignore
                saveAction={(evt, files) => {
                    // @ts-ignore TODO ts-ignore
                    files?.length > 0 ? saveDobroAction(files[0]) : saveDobroAction();
                }}
                sendToVerifyAction={() => {
                    // @ts-ignore TODO ts-ignore
                    verifyGood();
                }}
                titleAction={setGoodTitle}
                goodTitleError={goodTitleError}
                // @ts-ignore TODO ts-ignore
                locationAction={(data) => {
                    goodLocation.current = data;
                }}
                goodLocationError={goodLocationError}
                descriptionAction={setGoodDescription}
                goodDescriptionError={goodDescriptionError}
                helperText="Puste pole!"
                sessionid={props.sessionid}
                lat={lat > 0 ? lat : givenLatitude ? givenLatitude : props.lat}
                lon={lon > 0 ? lon : givenLongitude ? givenLongitude : props.lon}
                city={props.city}
                apikey={props.apikey}
                searchByIdHandler={auto_searchByIdHandler}
                formSubmitHandler={auto_formSubmitHandler}
                isValid={sValid}
                enteredValue={enteredValue}
                searchResults={searchResults}
                modapMap={preview && props.auth.epid === "ADMIN" ? false : true}
            ></AddGoodForm>
        ) : (
            <AcceptGoodForm
                reguralText={
                    // @ts-ignore TODO ts-ignore
                    editEntity?.current ? editEntity?.current?.description : " "
                }
                // @ts-ignore TODO ts-ignore
                header={editEntity?.current ? editEntity?.current?.shortDescription : " "}
                // @ts-ignore TODO ts-ignore
                goodName={editEntity ? editEntity?.current?.shortDescription : " "}
                // @ts-ignore TODO ts-ignore
                misotName={editEntity ? editEntity?.current?.epid : " "}
                goodPointsValueHandler={setnumberOfPointsForGood}
                justificationValueHandler={setvalidationPointsForGood}
                cancelActionHandler={() => {
                    handleCloseNewDobro();
                }}
                // @ts-ignore TODO ts-ignore
                saveActionHandler={(theFile) => {
                    if (
                        !numberOfPointsForGood ||
                        // @ts-ignore TODO ts-ignore
                        numberOfPointsForGood.trim().length === 0 ||
                        !validationPointsForGood ||
                        validationPointsForGood.trim().length === 0
                    ) {
                        setOpenEmpty(true);
                        return;
                    }
                    if (numberOfPointsForGood && isNaN(numberOfPointsForGood)) {
                        setopenNumber(true);
                        return;
                    }
                    setOpenEmpty(false);
                    if (editEntity?.current) {
                        if (
                            editEntity?.current &&
                            // @ts-ignore TODO ts-ignore
                           editEntity?.current?.goodStage === "Acceptance stage 2" &&
                            props.auth.epid === "ADMIN"
                        ) {
                            fetchData(
                                {
                                    url: `${getUrl()}/api/v1/goodWorkflow`,
                                    method: "POST",
                                    headers: {
                                        accept: "*/*",
                                        Authorization: `Bearer ${props.auth?.user}`,
                                        "Content-Type": "application/json",
                                    },
                                    body: {
                                        goodAction: `Accept`,
                                        good: {
                                            // @ts-ignore TODO ts-ignore
                                            id: editEntity?.current?.id,
                                            // @ts-ignore TODO ts-ignore
                                            parentId: editEntity?.current?.parentId,
                                            // @ts-ignore TODO ts-ignore
                                            goodStage: editEntity?.current?.goodStage,
                                            // @ts-ignore TODO ts-ignore
                                            vcreated: editEntity?.current?.created,
                                            // @ts-ignore TODO ts-ignore
                                            updated: editEntity?.current?.updated,
                                            // @ts-ignore TODO ts-ignore
                                            owner: editEntity?.current?.owner,
                                            epid: `${props.auth?.epid}`,
                                            geographicCoordinates:
                                            // @ts-ignore TODO ts-ignore
                                            editEntity?.current?.geographicCoordinates,
                                            // @ts-ignore TODO ts-ignore
                                            shortDescription: editEntity?.current?.shortDescription,
                                            // @ts-ignore TODO ts-ignore
                                            description: editEntity?.current?.description,
                                            // @ts-ignore TODO ts-ignore
                                            goodDate: editEntity?.current?.goodDate,
                                            // @ts-ignore TODO ts-ignore
                                            score: parseInt(numberOfPointsForGood),
                                            // @ts-ignore TODO ts-ignore
                                            rejectReason: editEntity?.current?.rejectReason,
                                            // @ts-ignore TODO ts-ignore
                                            acceptReason: `${validationPointsForGood}`,
                                            // @ts-ignore TODO ts-ignore
                                            deleteReason: editEntity?.current?.deleteReason,
                                            // @ts-ignore TODO ts-ignore
                                            city: editEntity?.current?.city,
                                            // @ts-ignore TODO ts-ignore
                                            provinceName: editEntity?.current?.provinceName,
                                            // @ts-ignore TODO ts-ignore
                                            districtName: editEntity?.current?.districtName,
                                            // @ts-ignore TODO ts-ignore
                                            streetName: editEntity?.current?.streetName,
                                            // @ts-ignore TODO ts-ignore
                                            buildNumber: editEntity?.current?.buildNumber,
                                            status: "Oczekuje na weryfikację",
                                        },
                                    },
                                },
                                async ():Promise<void> => {
                                    // @ts-ignore TODO ts-ignore
                                    afterAddingGoodHandler();
                                }
                            );
                            return;
                        }
                    }
                }}
                disableVerifyButton={false}
                delay={100}
            >
                {" "}
            </AcceptGoodForm>
        );

    return (
        <Box
            sx={{
                width: "100%",
                height: "80%"
            }}
        >
            <Box>
                {content}
                {props.auth.epid !== "ADMIN" && (
                    <Box id="mapContainer" className={classes.mapContainer}>

                        <Box
                            id="mapa-glowny"
                            sx={{
                                [Theme.breakpoints.up("desktop")]: {
                                    width: "100%",
                                    height: "575px",
                                    borderRadius: "24px",
                                    position: "sticky",
                                    top: "calc(1em + 12vh)",
                                },

                                [Theme.breakpoints.down("desktop")]: {
                                    width: "100%",
                                    height: "405px",
                                    borderRadius: "24px",
                                    position: "sticky",
                                    top: "calc(1em + 12vh)",
                                },

                                gridArea: "maptotal",
                                borderRadius: "24px",
                                pr: "2%",
                                mt: -5,
                            }}
                        >


                            <MapContainer
                                lat={!Number.isNaN(props?.lat) ? props?.lat : 50.369}
                                lon={!Number.isNaN(props?.lon) ? props?.lon : 19.1789}
                                companies={data}
                                points={data}
                                references={refs}
                                zoom={10}
                                apikey={props.apikey}
                                place={{
                                    geographicCoordinates: {
                                        lat: !Number.isNaN(props.lat) ? props.lat : 50.369,
                                        lon: !Number.isNaN(props.lon) ? props.lon : 19.1789,
                                    },
                                    companyName: "placeYouAreLookingFor.addressSearch",
                                }}
                            />

                        </Box>


                    </Box>
                )}

            </Box>

            <Modal
                open={openNewDobro}
                onClose={():void => {
                    handleCloseNewDobro();
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                {goodFormModal}
            </Modal>

            <Modal
                open={openHistory}
                onClose={():void => {
                    setopenHistory((value):boolean => !value);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <GoodHistoryCard
                    label="Historia dobra"
                    text="Tekst historii dobra"
                    buttonAction={setopenHistory}
                    itemList={itemList}
                ></GoodHistoryCard>
            </Modal>

            <Modal
                open={confirmation}
                onClose={():void => {
                    setConfirmation((value):boolean => !value);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ConfirmationForm
                    goodName={
                        // @ts-ignore TODO ts-ignore
                        editEntity?.current?.shortDescription ? editEntity?.current?.shortDescription : editEntity?.current?.description
                    }
                    misotName={
                        // @ts-ignore TODO ts-ignore
                        editEntity?.current?.epid ? editEntity?.current?.epid : "lala"
                    }
                    disableVerifyButton={
                        // @ts-ignore TODO ts-ignore
                        editEntity?.current?.status === "Akceptacja" ? false : false
                    }
                    accordionText={"test"}
                    buttonLabel={
                        editEntity.current && props.auth.epid === "ADMIN" ? "Odrzuć" : "Usuń"
                    }
                    cancelActionHandler={() => {
                        // @ts-ignore TODO ts-ignore
                        editEntity.current = {};
                        setConfirmation((value) => !value);
                    }}
                    boldText={
                        // @ts-ignore TODO ts-ignore
                        editEntity?.current?.status === "Usunięto"
                            ? "Dobro odrzucone"
                            // @ts-ignore TODO ts-ignore
                            : editEntity?.current?.status === "Oczekuje na weryfikację"
                                ? "W trakcie weryfikacji"
                                : props.auth.epid === "ADMIN"
                                    ? "Czy na pewno chcesz odrzucić"
                                    : "Czy na pewno chcesz usunąć"
                    }
                    saveActionHandler={() => {
                        let dobro = editEntity.current;

                        if (dobro && props.auth.epid === "ADMIN") {
                            setopenInprogress(true);

                            fetchData(
                                {
                                    url: `${getUrl()}/api/v1/goodWorkflow`,
                                    method: "POST",
                                    headers: {
                                        accept: "*/*",
                                        Authorization: `Bearer ${props.auth?.user}`,
                                        "Content-Type": "application/json",
                                    },
                                    body: {
                                        goodAction: `Reject`,
                                        good: {
                                            // @ts-ignore TODO ts-ignore
                                            id: dobro?.id,
                                            // @ts-ignore TODO ts-ignore
                                            parentId: dobro?.id,
                                            // @ts-ignore TODO ts-ignore
                                            goodStage: dobro?.goodStage,
                                            // @ts-ignore TODO ts-ignore
                                            created: dobro?.created,
                                            // @ts-ignore TODO ts-ignore
                                            updated: dobro?.updated,
                                            // @ts-ignore TODO ts-ignore
                                            owner: dobro?.owner,
                                            epid: `${props.auth?.epid}`,
                                            // @ts-ignore TODO ts-ignore
                                            geographicCoordinates: dobro?.geographicCoordinates,
                                            // @ts-ignore TODO ts-ignore
                                            shortDescription: dobro?.shortDescription,
                                            // @ts-ignore TODO ts-ignore
                                            description: dobro?.description,
                                            // @ts-ignore TODO ts-ignore
                                            goodDate: dobro?.goodDate,
                                            // @ts-ignore TODO ts-ignore
                                            score: parseInt(dobro?.score),
                                            // @ts-ignore TODO ts-ignore
                                            rejectReason: dobro?.rejectReason,
                                            // @ts-ignore TODO ts-ignore
                                            acceptReason: dobro?.acceptReason,
                                            // @ts-ignore TODO ts-ignore
                                            deleteReason: dobro?.deleteReason,
                                            // @ts-ignore TODO ts-ignore
                                            city: dobro?.city,
                                            // @ts-ignore TODO ts-ignore
                                            provinceName: dobro?.provinceName,
                                            // @ts-ignore TODO ts-ignore
                                            districtName: dobro?.districtName,
                                            // @ts-ignore TODO ts-ignore
                                            streetName: dobro?.streetName,
                                            // @ts-ignore TODO ts-ignore
                                            buildNumber: dobro?.buildNumber,
                                            status: "Nowy",
                                        },
                                    },
                                },
                                // @ts-ignore TODO ts-ignore
                                (data):void => {
                                    editEntity.current = {...data};
                                    setopenInprogress(false);
                                    setConfirmation(false);

                                    let reqConfig = "";
                                    if (props.auth.epid !== "ADMIN") {
                                        // @ts-ignore TODO ts-ignore
                                        reqConfig = {
                                            // url: `${getUrl()}/api/v1/goodWorkflow?limit=100000`,
                                            url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                                            // method: 'GET',
                                            method: "POST",
                                            headers: {
                                                accept: "*/*",
                                                Authorization: `Bearer ${props.auth.user}`,
                                                "Content-Type": "application/json",
                                            },
                                            body: {
                                                epid: `${props.auth.epid}`,
                                                limit: 100000,
                                                offset: 0,
                                            },
                                        };
                                    } else {
                                        // @ts-ignore TODO ts-ignore
                                        reqConfig = {
                                            // url: `${getUrl()}/api/v1/goodWorkflow?limit=100000`,
                                            url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                                            // method: 'GET',
                                            method: "POST",
                                            headers: {
                                                accept: "*/*",
                                                Authorization: `Bearer ${props.auth.user}`,
                                                "Content-Type": "application/json",
                                            },
                                            body: {
                                                limit: 100000,
                                                offset: 0,
                                            },
                                        };
                                    }

                                    fetchData(reqConfig, preparePointsOfGood);
                                }
                            );

                            return;
                        }

                        setopenInprogress(true);
                        fetchData(
                            {
                                url: `${getUrl()}/api/v1/goodWorkflow`,
                                method: "POST",
                                headers: {
                                    accept: "*/*",
                                    Authorization: `Bearer ${props.auth?.user}`,
                                    "Content-Type": "application/json",
                                },
                                body: {
                                    goodAction: `Delete`,
                                    good: {
                                        // @ts-ignore TODO ts-ignore
                                        id: dobro?.id,
                                        // @ts-ignore TODO ts-ignore
                                        parentId: dobro?.id,
                                        // @ts-ignore TODO ts-ignore
                                        goodStage: dobro?.goodStage,
                                        // @ts-ignore TODO ts-ignore
                                        created: dobro?.created,
                                        // @ts-ignore TODO ts-ignore
                                        updated: dobro?.updated,
                                        // @ts-ignore TODO ts-ignore
                                        owner: dobro?.owner,
                                        epid: `${props.auth?.epid}`,
                                        // @ts-ignore TODO ts-ignore
                                        geographicCoordinates: dobro?.geographicCoordinates,
                                        // @ts-ignore TODO ts-ignore
                                        shortDescription: dobro?.shortDescription,
                                        // @ts-ignore TODO ts-ignore
                                        description: dobro?.description,
                                        // @ts-ignore TODO ts-ignore
                                        goodDate: dobro?.goodDate,
                                        // @ts-ignore TODO ts-ignore
                                        score: parseInt(dobro?.score),
                                        // @ts-ignore TODO ts-ignore
                                        rejectReason: dobro?.rejectReason,
                                        // @ts-ignore TODO ts-ignore
                                        acceptReason: dobro?.acceptReason,
                                        // @ts-ignore TODO ts-ignore
                                        deleteReason: dobro?.deleteReason,
                                        // @ts-ignore TODO ts-ignore
                                        city: dobro?.city,
                                        // @ts-ignore TODO ts-ignore
                                        provinceName: dobro?.provinceName,
                                        // @ts-ignore TODO ts-ignore
                                        districtName: dobro?.districtName,
                                        // @ts-ignore TODO ts-ignore
                                        streetName: dobro?.streetName,
                                        // @ts-ignore TODO ts-ignore
                                        buildNumber: dobro?.buildNumber,
                                        status: "Zarchiwizowano",
                                    },
                                },
                            },
                            // @ts-ignore TODO ts-ignore
                            (data): void => {
                                // editEntity.current = ({ ...data});
                                setopenInprogress(false);
                                setConfirmation(false);

                                let reqConfig = "";
                                if (props.auth.epid !== "ADMIN") {
                                    // @ts-ignore TODO ts-ignore
                                    reqConfig = {
                                        // url: `${getUrl()}/api/v1/goodWorkflow?limit=100000`,
                                        url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                                        // method: 'GET',
                                        method: "POST",
                                        headers: {
                                            accept: "*/*",
                                            Authorization: `Bearer ${props.auth.user}`,
                                            "Content-Type": "application/json",
                                        },
                                        body: {
                                            epid: `${props.auth.epid}`,
                                            limit: 100000,
                                            offset: 0,
                                        },
                                    };
                                } else {
                                    // @ts-ignore TODO ts-ignore
                                    reqConfig = {
                                        // url: `${getUrl()}/api/v1/goodWorkflow?limit=100000`,
                                        url: `${getUrl()}/api/v1/goodWorkflow/filteredGood`,
                                        // method: 'GET',
                                        method: "POST",
                                        headers: {
                                            accept: "*/*",
                                            Authorization: `Bearer ${props.auth.user}`,
                                            "Content-Type": "application/json",
                                        },
                                        body: {
                                            limit: 100000,
                                            offset: 0,
                                        },
                                    };
                                }

                                fetchData(reqConfig, preparePointsOfGood);
                            }
                        );

                        // @ts-ignore TODO ts-ignore
                        editEntity.current = {};

                        return;
                    }}
                />
            </Modal>

            {
                <Popup
                    openPopup={openPopUp}
                    title={popUpTitle}
                    setOpenPopup={():void => {
                        setopenPopUp(false);
                    }}
                >
                    <span>
                        {
                            // @ts-ignore TODO ts-ignore
                            httpError?.data?.errorCode
                                // @ts-ignore TODO ts-ignore
                                ? `${"errorCode" in httpError?.data
                                    // @ts-ignore TODO ts-ignore
                                    ? httpError?.data?.errorCode
                                    : ""
                                }
                         ${
                                    // @ts-ignore TODO ts-ignore
                                    "errorSubCode" in httpError?.data
                                        // @ts-ignore TODO ts-ignore
                                        ? httpError?.data?.errorSubCode
                                        : ""
                                }
                         ${
                                    // @ts-ignore TODO ts-ignore
                                    "message" in httpError?.data
                                        // @ts-ignore TODO ts-ignore
                                        ? httpError?.data?.message
                                        : ""
                                }
                         ${// @ts-ignore TODO ts-ignore
                                    "info" in httpError?.data
                                        // @ts-ignore TODO ts-ignore
                                        ? httpError?.data?.info
                                        : ""
                                }`
                                : error?.data?.errorCode
                                    ? `${"errorCode" in error?.data ? error?.data?.errorCode : ""}
                             ${"errorSubCode" in error?.data
                                        ? error?.data?.errorSubCode
                                        : ""
                                    }
                             ${"message" in error?.data
                                        ? error?.data?.message
                                        : ""
                                    }
                             ${"info" in error?.data ? error?.data?.info : ""}`
                                    : httpError
                                        ? httpError
                                        : error
                                            ? error
                                            : popUpError}
                    </span>
                </Popup>
            }

            {
                <Popup
                    openPopup={open} setOpenPopup={() => {
                    setOpen(false);
                }}
                >
                    <span>
                        {
                            // @ts-ignore TODO ts-ignore
                            httpError?.data?.errorCode
                                // @ts-ignore TODO ts-ignore
                                ? `${"errorCode" in httpError?.data
                                    // @ts-ignore TODO ts-ignore
                                    ? httpError?.data?.errorCode
                                    : ""
                                }
                    ${
                                    // @ts-ignore TODO ts-ignore
                                    "errorSubCode" in httpError?.data
                                        // @ts-ignore TODO ts-ignore
                                        ? httpError?.data?.errorSubCode
                                        : ""
                                }
                    ${// @ts-ignore TODO ts-ignore
                                    "message" in httpError?.data
                                        // @ts-ignore TODO ts-ignore
                                        ? httpError?.data?.message
                                        : ""
                                }
                    ${
                                    // @ts-ignore TODO ts-ignore
                                    "info" in httpError?.data ? httpError?.data?.info : ""}`
                                : error?.data?.errorCode
                                    ? `${"errorCode" in error?.data ? error?.data?.errorCode : ""}
                    ${"errorSubCode" in error?.data
                                        ? error?.data?.errorSubCode
                                        : ""
                                    }
                    ${"message" in error?.data ? error?.data?.message : ""}
                    ${"info" in error?.data ? error?.data?.info : ""}`
                                    // @ts-ignore TODO ts-ignore
                                    : httpError?.message
                                        // @ts-ignore TODO ts-ignore
                                        ? httpError.message
                                        : error?.message
                                            ? error.message
                                            : "Błąd nieznany"}
                    </span>
                </Popup>
            }

            {
                <Popup
                    openPopup={openEmpty}
                    message={emptyErrorMsg}
                    setOpenPopup={() => {
                        setOpenEmpty(false);
                    }}
                >
                    <span>{emptyErrorMsg}</span>
                </Popup>
            }

            {
                <Popup
                    title={inprogressMsg}
                    openPopup={openInprogress || isLoading}
                    message={inprogressMsg}
                    disabledButton={true}
                    setOpenPopup={() => {
                        setopenInprogress(false);
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            width: "20%",
                            justifyContent: "center",
                        }}
                    >
                        <Circles
                            height="50"
                            width="50"
                            radius="9"
                            color="#2bfece"
                            ariaLabel="loading"
                            wrapperStyle
                            wrapperClass
                        />
                    </Box>
                </Popup>
            }

            {
                <Popup
                    title="wartość musi być liczbą"
                    openPopup={openNumber}
                    message={inprogressMsg}
                    disabledButton={false}
                    setOpenPopup={() => {
                        setopenNumber(false);
                    }}
                ></Popup>
            }
            {
                <Popup
                    title="Funkcja niezaimplementowana, jeszcze."
                    openPopup={notImplemented}
                    message="Funkcja niezaimplementowana, jeszcze."
                    disabledButton={false}
                    setOpenPopup={() => {
                        setNotImplemented(false);
                    }}
                ></Popup>
            }
        </Box>

    );
};


